import React from "react";
import PropTypes from "prop-types";
import { Field, FieldArray, reduxForm } from "redux-form";
import { RadioTab } from "components/common/radio-tab";
import { Button } from "components/common/button";
import { TextField } from "components/common/text-field";
import { ActiveFilterItem } from "components/documents/filters/active-filter-item";
import styles from "components/documents/forms/batch-download-form.scss";

const exportTypeOptions = [
  { key: "csv", name: "CSV" },
  { key: "pdf", name: "PDF" }
];

const Form = (props) => (
  <div>
    <div>Choose an export type</div>
    <Field
      component={ radioTabField }
      name="exportType"
    />
    <p className={ styles.info }>
      Your export will take a few short minutes to prepare. We&#39;ll email you and any other recipients below when
      it&#39;s ready!
    </p>
    <FieldArray
      component={ (p) => renderFormContents(p, props.defaultEmail, props.onSave, props.onCancel, props.isLoading) }
      name="emails"
    />
  </div>
);

Form.propTypes = {
  defaultEmail: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};


const radioTabField = (props) => (
  <RadioTab
    onChange={ (option) => props.input.onChange(option.key) }
    options={ exportTypeOptions }
    selectedOptionKey={ props.input.value }
  />
);

radioTabField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }).isRequired
};

const renderFormContents = (props, defaultEmail, onSave, onCancel, isLoading) => {
  const fields = props.fields;
  if (props.meta.pristine && (fields.getAll() || []).length === 0) {
    fields.push(defaultEmail);
  }
  const selectedEmailField = (email, index) => (
    <div className={ styles["email-row"] } key={ `${email}-${index}` }>
      <ActiveFilterItem name={ email } onRemove={ () => fields.remove(index) } />
    </div>
  );

  return (
    <div>
      <Field
        component={ (fieldProps) => EmailTextField(fieldProps, fields) }
        name="newEmail"
      />
      <div className={ styles["emails-container"] }>
        { (fields.getAll() || []).map(selectedEmailField) }
      </div>
      <div className={ styles.actions }>
        <Button link onClick={ onCancel }>cancel</Button>
        <Button
          disabled={ (props.fields.getAll() || []).length === 0 }
          loading={ isLoading }
          onClick={ onSave }
          primary
        >
          Send
        </Button>
      </div>
    </div>
  );
};

renderFormContents.propTypes = {
  fields: PropTypes.shape({
    getAll: PropTypes.func
  }).isRequired,
  meta: PropTypes.shape({
    pristine: PropTypes.bool
  }).isRequired
};

const EmailTextField = (props, fields) => {
  const onSubmit = (e) => {
    e.preventDefault();
    const value = props.input.value;
    if (value === "") {
      return;
    }
    fields.push(props.input.value);
    props.input.onChange("");
  };

  return (
    <form className={ styles["add-email-container"] } onSubmit={ onSubmit } >
      <div className={ styles["add-email_container__text-field-container"] }>
        <TextField
          onChange={ props.input.onChange }
          placeholder="Email..."
          type="email"
          value={ props.input.value }
        />
      </div>
      <div className={ styles["add-email_container__button-container"] }>
        <Button type="submit">+</Button>
      </div>
    </form>
  );
};

EmailTextField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.string
  }).isRequired
};

export const BatchDownloadForm = reduxForm({
  form: "batchDownloadDocumentsForm",
  initialValues: {
    exportType: "csv"
  }
})(Form);



// WEBPACK FOOTER //
// ./src/js/components/documents/modals/forms/batch-download-form.jsx